<div class="compare__content-wrapper card__wrapper">
  <mat-card appearance="outlined">
    <mat-card-title class="card__title">
      <h1>Country Profile Report</h1>
    </mat-card-title>
    <mat-card-content class="compare__table-wrapper">
      <app-section-report></app-section-report>
    </mat-card-content>
  </mat-card>
</div>